import React from 'react';
import { Link }  from 'react-router-dom';
import ReactTooltip from 'react-tooltip'
import './theme.css';

class CustomButton extends React.Component {
  constructor(props){
    super(props);
    //this.state=

    /*
      props:
      url, action,
      x, y, tooltip, icon, text, big,
      download, nav, newTab
    */

    this.tooltipid = 'tt' + Math.floor(Math.random() * 1001);

    this.st = {
      position: "static",
      fontSize: "15px"
    };
    if(props.x && props.y)
    {
      this.st = {
        position: "fixed",
        left: props.x+"px",
        top: props.y+"px"
      }
    }
    this.dl = "";
    if(props.download)//TODO
      this.dl = "wallpaper";
    if(props.big)
      this.st.fontSize = "42px";
  }

  render(){
    let buttonContent=[];
    if(this.props.icon)
      buttonContent.push(<i key="0" className="material-icons" style={{fontSize: this.st.fontSize}}>{this.props.icon}</i>);
    if(this.props.text)
      buttonContent.push(<span key="1">{this.props.text}</span>);

    return(
      <div>
        {(this.props.newTab &&
          <a href={this.props.url} target="_blank" rel="noopener" onClick={this.props.action} className="gomb" style={this.st} data-tip data-for={this.tooltipid}>
            {buttonContent}
          </a>)
        ||

        (this.props.download &&
          <a href={this.props.url} download="Download" onClick={this.props.action} className="gomb" style={this.st} data-tip data-for={this.tooltipid}>
            {buttonContent}
          </a>)
        ||

        (this.props.nav &&
          <Link to={this.props.url} onClick={this.props.action} className="gomb" style={this.st} data-tip data-for={this.tooltipid}>
            {buttonContent}
          </Link>)
        ||
        (this.props.action && !(this.props.newTab&&this.props.download&&this.props.nav) &&
          <a onClick={this.props.action} className="gomb" style={this.st} data-tip data-for={this.tooltipid}>
            {buttonContent}
          </a>)
        }
        {this.props.tooltip &&
          <ReactTooltip id={this.tooltipid} type='light' effect='solid' place="right">
            <span>{this.props.tooltip}</span>
          </ReactTooltip>
        }
      </div>
    );
  }
}

export default CustomButton;

//{this.props.icon &&
//  <i className="material-icons" style={{fontSize: this.st.fontSize}}>{this.props.icon}</i>
//}
//{this.props.text &&
//  <span>{this.props.text}</span>
//}



// WEBPACK FOOTER //
// ./src/Component/CustomButton.js